import { HTTP } from "@/api";

export default {
  activeProfileId({ commit }, id) {
    commit("activeProfileId", id);
  },
  getProfiles({ commit }) {
    return HTTP.get("/profiles").then(res => {
      if (res.data && !res.data.error) {
        commit("fetchProfiles", res.data.profiles);
      }
    });
  },
  createProfile({ dispatch }, data) {
    return HTTP.post("/profiles", data).then(res => {
      if (res.data && res.data.success) {
        dispatch("getProfiles");
      } else {
        console.log(res);
        if (res.data && res.data.error) throw new Error(res.data.error);
        else throw new Error("Something went wrong!");
      }
    });
  },
  removeProfile({ commit }, id) {
    return HTTP.delete(`/profiles/${id}`).then(res => {
      if (res.data && res.data.result) {
        commit("removeProfile", id);
      } else {
        console.log(res);
        if (res.data && res.data.error) throw new Error(res.data.error);
        else throw new Error("Something went wrong!");
      }
    });
  },
  updateProfile({ commit, state }, { id, data }) {
    if (!id || !data) throw new Error("Wrong update data");
    const profile = state.profiles.list.find(profile => profile.id === id);
    if (!profile) throw new Error("Wrong profile specified!");
    Object.keys(data).forEach(key => {
      // eslint-disable-next-line fp/no-mutation
      profile[key] = data[key];
    });
    commit("filterLoading", true);
    return HTTP.put(`/profiles/${id}`, profile).then(res => {
      if (res.data) {
        commit("updateProfile", res.data);
      } else {
        console.log(res);
        if (res.data && res.data.error) throw new Error(res.data.error);
        else throw new Error("Something went wrong!");
      }
    });
  },
  saveProfileSettings({ dispatch, state }, id) {
    const profile = state.profiles.list.find(profile => profile.id === id);
    if (!profile) throw new Error("Save profile settings failure!");
    dispatch("updateProfile", { id, data: { settings: profile.settings } });
  },
  changeProfileName({ state, commit }, { id, name }) {
    if (!id) throw new Error("Profile ID not passing");
    const profile = state.profiles.list.find(profile => profile.id === id);
    if (!profile) throw new Error("Profile not found");
    commit("updateProfile", { ...profile, name });
  }
};
